import { formDataToStructuredObject } from "utils/formDataUtils";
import { addToasterActionData } from "hooks/useToasterFromActionData";
import { BillingInputName, CouponActions, CouponInputName, FormInputName } from "v2/dataroutes/BillingData";
import { addCouponsAction } from "routes/data-routes/billing-data/coupons/active-coupons/actions/addCouponsAction";
import { removeCouponAction } from "routes/data-routes/billing-data/coupons/active-coupons/actions/removeCouponAction";
import { ActiveCouponsDataRouteType } from "routes/data-routes/billing-data/coupons/active-coupons/route.meta";
import { v4 as uuidv4 } from "uuid";


export const action: ActiveCouponsDataRouteType["route"]["action"] = async ({ request }) => {
  const formData = formDataToStructuredObject(await request.formData());
  const requestConfig = {
    signal: request.signal,
    headers: {
      "Idempotency-Key": uuidv4()
    }
  };

  switch (formData[FormInputName.action]) {
    case CouponActions.add_coupon.value:
      return addCouponsAction({
        couponCodes: [ formData[CouponInputName.couponCode] ],
        targetPlanSlug: formData[BillingInputName.targetPlanSlug]
      }, requestConfig);

    case CouponActions.remove_coupon.value:
      return removeCouponAction(
        formData[CouponInputName.couponCode],
        requestConfig
      );

    default:
      return addToasterActionData(
        { error: { message: `Unknown coupon action ${ formData[FormInputName.action] }` } },
        {
          toastId: "unknown-coupon-action-error",
          type: "error",
          title: "Error",
          description: "An unexpected error occurred. Please try again."
        }
      );
  }
};
